<template>
  <div class="notifications-page-content">
    <DashboardWelcome class="notifications-page-content__welcome" hide-title></DashboardWelcome>

    <div class="notifications-page-content__header">
      <router-link to="/" tag="a" class="notifications-page-content__back-button">
        <LLButton small secondary>
          <template #icon-left>
            <ArrowMiniIcon class="notifications-page-content__back-button-arrow"></ArrowMiniIcon>
          </template>
          {{ $t('notifications-page.back_button') }}
        </LLButton>
      </router-link>
      <div class="notifications-page-content__title">
        <div class="notifications-page-content__title-icon">
          <NotificationIcon />
        </div>
        <h3 class="notifications-page-content__title-text">{{ $t('notifications-page.title') }}</h3>
      </div>
    </div>
    <div class="notifications-page-content__divider"></div>

    <div class="notifications-page-content__content">
      <notifications-list
        class="notifications-page-content__list"
        :unread-only="false"
        hide-items-actions
        :uncleared-only="false"
      />
    </div>
  </div>
</template>

<script>
import DashboardWelcome from '@/components/pages/dashboard/DashboardWelcome.vue'
import NotificationsList from '@/components/modules/notifications/notifications-list.vue'
import LLButton from '@/components/common/ui-components/LLButton.vue'
import NotificationIcon from '@/assets/icons/NotificationIcon.vue'

export default {
  name: 'NotificationsPageContent',
  components: { NotificationIcon, LLButton, NotificationsList, DashboardWelcome }
}
</script>

<style scoped lang="scss">
.notifications-page-content {
  &__back-button {
    @screen sm {
      @apply absolute;
    }
    &-arrow {
      @apply rotate-180 transform;
    }
  }
  &__header {
    @apply mt-4;
    @screen sm {
      @apply relative flex items-center;
    }
  }
  &__title {
    @apply flex items-center mt-4 w-full justify-center;
    @screen sm {
      @apply flex-1 flex justify-center mt-0;
    }
    &-text {
      @apply min-w-0 truncate;
    }
    &-icon {
      @apply mr-1;
    }
  }
  &__divider {
    @apply my-4;
    @apply border-t border-neutral-01-50;
  }

  &__content {
    @apply flex flex-col items-center;
  }

  &__list {
    max-width: 600px;
    width: 100%;
  }
}
</style>
